import LogoS from '@/assets/images/logos/logo-new-l.svg'
import LogoSubstitle from '@/assets/images/logos/logo_sub.png'
import { updateUserAvatar } from '@/services/images'
import { updateSelectedRoom } from '@/store/rooms/rooms.actions'
import { persistor } from '@/store/store'
import { AppDispatch } from '@/types'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faGear, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'
import useSignOut from 'react-auth-kit/hooks/useSignOut'
import { useDispatch } from 'react-redux'
import { Link, NavLink, useLocation } from 'react-router-dom'
import Modal from '../Modal'
import ChannelList from './ChannelList'
import NavBar from './Navbar'
import './index.scss'

const Sidebar = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isAuthenticated = useIsAuthenticated()
  const [show, setShow] = useState(false)
  const [userAvatar, setUserAvatar] = useState<File | null>(null)
  const [previewUrl, setPreviewUrl] = useState('')
  const signOut = useSignOut()

  const signOutFunc = () => {
    signOut()
    persistor.purge()
  }
  const location = useLocation()
  const isOnExcludedRoutes = location.pathname === '/playground/channel'

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setUserAvatar(file)
      setPreviewUrl(URL.createObjectURL(file))
    }
  }

  const handleUserSettings = async () => {
    const formData = new FormData()
    if (!userAvatar) return
    formData.append('file', userAvatar)
    updateUserAvatar(formData)
    setShow(false)
    dispatch(updateSelectedRoom(null))
  }

  return (
    <div className="nav-bar bg-gray-900 w-24 h-full absolute top-0 z-30 min-h-[500px]">
      <Link className="block py-2" to="/">
        <img
          src={LogoS}
          alt="logo"
          className="block mx-auto w-16 h-auto mb-2"
        />
        <img
          src={LogoSubstitle}
          alt="vargasluisGu"
          className="block mx-auto w-20 h-auto"
        />
      </Link>
      {isOnExcludedRoutes && isAuthenticated ? <ChannelList /> : <NavBar />}
      <ul className="absolute bottom-5 w-full text-center list-none p-0 m-0">
        {isAuthenticated ? (
          <li className="py-2">
            <NavLink
              to="/playground"
              onClick={signOutFunc}
              className="block bg-gray-800 text-white p-2 rounded"
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                className="text-gray-500 text-2xl hover:text-primary"
              />
            </NavLink>
          </li>
        ) : null}
        <li className="py-2">
          <a
            href="https://www.linkedin.com/in/luis-v-5122b8149/"
            target="_blank"
            rel="noreferrer"
            className="block"
          >
            <FontAwesomeIcon
              icon={faLinkedin}
              className="text-gray-500 text-2xl hover:text-primary"
            />
          </a>
        </li>
        <li className="py-2">
          <a
            href="https://github.com/luisVargasGu"
            target="_blank"
            rel="noreferrer"
            className="block"
          >
            <FontAwesomeIcon
              icon={faGithub}
              className="text-gray-500 text-2xl hover:text-primary"
            />
          </a>
        </li>
        <li className="py-2" onClick={() => setShow(true)}>
          <div className="block cursor-pointer">
            <FontAwesomeIcon
              icon={faGear}
              className="text-gray-500 text-2xl hover:text-primary"
            />
          </div>
        </li>
      </ul>
      <Modal
        title="User Settings"
        show={show}
        handleClose={() => setShow(false)}
      >
        <div className="p-4">
          <label className="block mb-2">User Avatar</label>
          <input
            type="file"
            onChange={handleFileChange}
            className="w-full p-2 mb-4 border"
          />
          {previewUrl && (
            <img
              src={previewUrl}
              alt="User Avatar Preview"
              className="w-32 h-32 mb-4 rounded-full object-cover"
            />
          )}
          <button
            onClick={handleUserSettings}
            className="
            bg-primary
            p-2
            my-2
            text-secondary
            text-lg
            rounded
            cursor-pointer
            hover:bg-primary-dark
          "
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Sidebar
